import React, { useContext, useEffect, useState } from "react";
import { ResourcesRoutes } from "~/http/routes";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "~/redux/Selectors";
import HistoryCard from "./components/ResourceHistoryCard";
import Breadcrumb from "~/components/Breadcrumb/Breadcrumb";
import { ToastContext } from "~/providers/ToastProvider";
import { Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ResourceHistoryCard from "./components/ResourceHistoryCard";
import { isEmpty } from "lodash";
import checkPermission from "~/helpers/checkPermission";

function ResourceHistory() {
  const { companyId } = useSelector(userSelector);
  const { resourceId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [resourceInputHistoryList, setResourceInputHistoryList] = useState([]);
  const [resourceOutputHistoryList, setResourceOutputHistoryList] = useState(
    [],
  );
  const { setToast } = useContext(ToastContext);

  const handleAddResourceInput = () => {
    setReload(!reload);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const [{ data: inputData }, { data: outputData }] = await Promise.all([
          ResourcesRoutes.getResourcesInputByResourceId(companyId, resourceId),
          ResourcesRoutes.getResourcesOutputByResourceId(companyId, resourceId),
        ]);

        setResourceInputHistoryList(inputData?.data || []);
        setResourceOutputHistoryList(outputData?.data || []);
      } catch (error) {
        console.error(error);
        setToast({
          type: "error",
          title: "Erro",
          message: "Um erro ocorreu durante a listagem dos recursos.",
          show: true,
          autohide: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    getData();
  }, [companyId, resourceId, reload]);

  return (
    <div>
      <Breadcrumb title="Recursos" routeToBack="/home/resources" />

      <h3 className="my-5">{`Entradas do Recurso: ${
        resourceInputHistoryList[0]?.resource_name ?? ""
      }`}</h3>

      <div
        className="d-flex flex-column"
        style={{
          marginBottom: "40px",
          marginTop: "20px",
          justifyContent: "center",
        }}
      >
        {isLoading ? (
          <LoadingOutlined style={{ fontSize: "4em" }} />
        ) : resourceInputHistoryList.length === 0 &&
          resourceOutputHistoryList.length === 0 ? (
          <Empty description="Nenhuma entrada realizada" />
        ) : (
          [...resourceInputHistoryList, ...resourceOutputHistoryList]
            ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
            .map((cardData) => (
              <ResourceHistoryCard
                key={cardData.id}
                data={cardData}
                isEditable={checkPermission("editar-recursos")}
                isOutput={!isEmpty(cardData.task_id)}
                handleAddResourceInput={handleAddResourceInput}
              />
            ))
        )}
      </div>
    </div>
  );
}

export default ResourceHistory;
